import { StorageKeys } from "phoenix/constants";
import { AppliedAppTheme, AppliedAppThemes } from "phoenix/constants/AppliedAppTheme";
import { useLocalStorage } from "./UseLocalStorage";

export const useAppTheme = () => useLocalStorage(StorageKeys.AppTheme, AppliedAppThemes.light);
